import React from "react";
import { createRoot } from "react-dom/client";
import StoreSelector from "./StoreSelector";

const renderStoreSelector = (productId) => {
  const body = document.querySelector("body");
  let root = document.querySelector(".js_store_selector_root");
  if (root) {
    const existingRoot = createRoot(root);
    existingRoot.unmount();
  } else {
    root = document.createElement("div");
    root.classList.add("js_store_selector_root");
    body.appendChild(root);
  }
  const newRoot = createRoot(root);
  newRoot.render(<StoreSelector productId={productId} />);
};

export default renderStoreSelector;